import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React, { createContext, useContext } from 'react'

import { triggersClient } from '../../../../../utils/apollo/api'
import { useModalData } from '../../../../../components/modals/ModalsContext'
import { usePaginatedQuery } from '../../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../../packages/kiti/components/helpers/LazyAction'
import StatePresenter from '../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = createContext()
const { Provider } = Context
export const useRoutinesState = () => useContext(Context) || {}
export const useRoutines = () => useRoutinesState()?.triggers || []

const QUERY = gql`
  query Triggers($page: Int, $limit: Int, $search: String, $sort: TriggerSort, $filter: TriggerFilter) {
    triggers(page: $page, limit: $limit, search: $search, sort: $sort, filter: $filter) {
      id
      name
      action
      conditions
      entity
      frequency
      event
      payload
      enabled
      readOnly
      insertedAt
      updatedAt
    }
  }
`

const RoutinesLoader = ({ children, uncontrolledChildren, folder }) => {
  const search = useSearch()
  const filter = useCleanFilterForRequest()
  const { entities } = useModalData() || {}

  const { data, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      limit: 10,
      search,
      sort: [
        { field: 'NAME', type: 'ASC' },
        { field: 'INSERTED_AT', type: 'ASC' }
      ],
      filter: {
        entities,
        folderIds: folder.id,
        routinesOnly: true,
        ...filter
      }
    },
    fetchPolicy: 'network-only',
    client: triggersClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default RoutinesLoader
